import { DEFAULT_QUESTIONS_SORT } from '@/constants/questions';

export default {
  namespaced: true,

  state: () => ({
    questions: [],
    pagination: {},
    sort: DEFAULT_QUESTIONS_SORT,
  }),

  getters: {
    productQuestions: (state) => state.questions,
    productQuestionsPagination: (state) => state.pagination,
    productQuestionsSort: (state) => state.sort,
  },

  actions: {
    async fetchQuestions({ commit }, { productId, sort, page }) {
      const {
        questions,
        pagination,
        sort: sortQuestions,
      } = await this.$apiBFF.getProductQuestions({ productId, sort, page });

      commit('setQuestions', questions);
      commit('setPagination', pagination);
      commit('setSort', sortQuestions);
    },

    async sendQuestion({ dispatch, rootGetters }, question) {
      try {
        await this.$apiBFF.sendQuestion({
          productId: rootGetters['product/item'].id,
          question,
        });

        dispatch('notifications/create', {
          type: 'success',
          title: 'Спасибо за ваш вопрос',
          message: 'Мы постараемся ответить на него в ближайшее время',
        }, { root: true });
      } catch (error) {
        dispatch('notifications/create', {
          title: 'Ошибка',
          message: 'Не удалось добавить вопрос. Повторите запрос позднее',
        }, { root: true });

        return Promise.reject();
      }
    },
  },

  mutations: {
    setQuestions(state, questions = []) {
      state.questions = questions;
    },

    setPagination(state, pagination = {}) {
      state.pagination = {
        ...state.pagination,
        ...pagination,
      };
    },

    setSort(state, sort = DEFAULT_QUESTIONS_SORT) {
      state.sort = sort;
    },
  },
};
